import { ForecastConfig } from './forecast-store';

export const nonForecastedResultStackId = 'nonForecastedResult';
export const forecastedResultStackId = 'forecastedResult';
export const isForecastEnabled = (forecastConfig: ForecastConfig | null) => forecastConfig;
